import {getter, setter} from '@stencil/client-side-storage';

export function updateRecentSearch({
  destination,
  hotelName = '',
  hotelCode = '',
  checkin,
  checkout,
  roomString,
  partner,
  country,
}) {
  const goHomeSearchesList = getter('go_home_searches');

  let searchesList = [];

  if (goHomeSearchesList && goHomeSearchesList.length) {
    searchesList = [...goHomeSearchesList];
  }

  let targetDestination = {...destination, t: destination.t};

  if ((!destination || !destination.n) && hotelCode) {
    targetDestination = {n: hotelName, _id: hotelCode, t: 'hotel'};
  }

  if (
    !searchesList.filter(
      item =>
        item.destination.n === targetDestination.n &&
        new Date(item.checkin.date).toDateString() === new Date(checkin.date).toDateString() &&
        new Date(item.checkout.date).toDateString() === new Date(checkout.date).toDateString() &&
        item.roomString === roomString,
    ).length
  ) {
    searchesList.unshift({
      checkin: checkin,
      checkout: checkout,
      roomString: roomString,
      destination: targetDestination,
      partner: partner,
      country,
    });

    setter('go_home_searches', searchesList);
  }
}

export function getRecentSearch() {
  return getter('go_home_searches');
}
